import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import ProfilePage from '../../components/ProfilePage';
import Utils from '../../utils';

const mapStateToProps = (state: StoreState) => {
	const {
		galleryInfos: { config: { clientId } },
		profile: {
			clientId: profileClientId,
			name,
			email,
			position,
			phone,
			isLoading,
			crmProviders,
			emailProvider,
			role,
		},
	} = state;

	return {
		clientId,
		name: name || '',
		email: email || '',
		position: position || '',
		phone: phone || '',
		isLoading,
		crmProviders,
		emailProvider,
		isProfileLoaded: !!profileClientId,
		isReadOnlyApp: Utils.isReadOnlyApp(role),
	};
};

export default connect(mapStateToProps)(ProfilePage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProfilePage/index.tsx